import { z } from "zod";

export const RegisterEmployeeSchema = z.object({
  full_name: z.string().min(2, "Full name is required"),
  date_of_birth: z.string().min(1, "Date of birth is required"),
  marital_status: z.string().optional(),
  gender: z.string().min(1, "Gender is required"),
  nationality: z.string().optional(),
  phone_number: z
    .string()
    .regex(
      /^[6-9]\d{9}$/,
      "Phone number must be a valid 10-digit Indian number"
    ),
  email: z.string().email("Invalid email address"),
  permanent_address: z.string().min(1, "Permanent address is required"),
  current_address: z.string().min(1, "Current address is required"),

  stateDistricts: z
    .array(
      z.object({
        state: z.string().min(1, "State is required").default(""),
        districts: z.array(z.string()).default([]),
      })
    )
    // .optional()
    .default([]),

  pin: z.string().regex(/^\d{6}$/, "PIN code must be a 6-digit number"),

  department: z.string().min(1, "Department is required"),
  designation: z.string().min(1, "Designation is required"),
  date_of_joining: z.string().min(1, "Date of joining is required"),
  reporting_manager: z.number().nullable().optional(),
  role: z.string().min(1, "Role is required"),
  employeement_type: z.string().min(1, "Employment type is required"),
  duration: z.string().optional(),
  start_date: z.string().optional(),
  end_date: z.string().optional(),

  adharcard_number: z
    .string()
    .regex(/^\d{12}$/, "Aadhar card number must be a 12-digit number"),

  pan_card_number: z
    .string()
    .regex(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "PAN must be in format ABCDE1234F"),

  passport_number: z
    .string()
    .optional(),

  bank_name: z.string().min(1, "Bank name is required"),
  branch: z.string().min(1, "Branch is required"),

  bank_ac_number: z
    .string()
    .regex(/^\d{9,18}$/, "Bank account number must be 9–18 digits"),

  ifsc_number: z
    .string()
    .regex(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code format"),

  pf_number: z
    .string()
    .optional(),
  
  uan_number: z
    .string()
    .optional(),

  esic_uan: z
    .string()
    .optional(),

  emergency_contact_name: z.string().optional(),
  emergency_contact_relationship: z.string().optional(),
  emergency_contact_number: z.string().optional(),
  emergency_contact_address: z.string().optional(),
});

export type RegistrationFormValues = z.infer<typeof RegisterEmployeeSchema>;
